class NetworkError extends Error {
  status
  detail
  cause

  constructor({ message, status, detail = undefined, cause = undefined }) {
    super(message)
    this.name = this.constructor.name
    this.status = status
    this.detail = detail
    this.cause = cause
  }

  toJSON() {
    return {
      name: this.name,
      message: this.message,
      status: this.status,
      detail: this.detail,
      cause: this.cause,
    }
  }
}

export function is400Error(status) {
  return status >= 400 && status < 500
}

export { NetworkError }
